module.exports = __webpack_public_path__ + "img/keyboard.9fe73b68.svg";